import { atom } from 'infrastructure/state/jotai.wrapper'
import {
  EdGateStandardsResp,
  KiddomStandardsResp,
  ContentStandardsChangelistResp,
} from './types'

// EdGate subject mapping atom
export const edgateSubjectAtom = atom<string | null>(null)

// Standards data atoms
export const edgateStandardsAtom = atom<EdGateStandardsResp | null>(null)
export const kiddomStandardsAtom = atom<KiddomStandardsResp | null>(null)
export const changelistAtom = atom<ContentStandardsChangelistResp | null>(null)
